import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loadingPage: false
  },
  mutations: {
    startLoading() {
      this.state.loadingPage = true
    },
    endLoading() {
      this.state.loadingPage = false;
    }
  }
});

export default store;


// WEBPACK FOOTER //
// ./src/store.js